export default __webpack_public_path__ + "static/course-55d8ebd8fa0023243a4ce749fee40457.png";